
export default {
    agregarCarrito({ commit }, item) {
      commit('ADD_ITEM_LOGIN',item)
    }, 
    toggleItemInWishList({ commit }, item) {
        commit('TOGGLE_ITEM_IN_WISH_LIST', item)
    },
    toggleItemInCart({ commit }, item) {
        commit('TOGGLE_ITEM_IN_CART', item)
    },
    additemInCart({ commit }, item) {
      return new Promise((resolve, reject) => {
        if(item.student.id_usuario_estudiante == null){
          location.reload();
        }
        else {

          var statusPreventa =  JSON.parse(localStorage.getItem('statusPreventa'));
      
          if(!statusPreventa) // cuando no es preventa canculo mi cantidad
          {
            // item['stock'] = item['stock'] - 5;
            // item['stock'] = item['stock'] - 1;
            item["cantidad"] = item["quantity"] = (item["cantidad"] == null) ? 1 : item["cantidad"];
            item["subtotal"] = _.round(item["price"] * item["cantidad"] ,4);
            item["total"]    = _.round( item["subtotal"],4);
            // item["total"]    = _.round( item["price"],4);
          } 
          else // cuando es preventa obtengo lo que necesito.
          {
            if(item["cantidad"] >= 1 ){
                item["quantity"] = item["cantidad"]
                item["subtotal"] = _.round(item["price"] * parseInt(item["quantity"]),4);
                item["total"]    = _.round( item["subtotal"],4);
            }
            else{
                item["cantidad"] = item["quantity"] = (item["cantidad"] == null) ? 1 : item["cantidad"];
                item["subtotal"] = _.round( item["price"] * item["cantidad"] ,4);
                item["total"]    = _.round( item["prisubtotalce"],4);
                // item["total"]    = _.round( item["price"],4);
    
            }
            var id_transporte = JSON.parse(localStorage.getItem('id_transporte'));
            var tipo_transporte =  JSON.parse(localStorage.getItem('tipo_transporte'));
            if(item['tipo_producto'] === tipo_transporte && item['cod_producto'] === id_transporte) item['stock']  = 1;
          }
    
    
          item["discount_in_percentage"] = Math.floor(Math.random() * 20) + 4
          item["offers_count"] = Math.floor(Math.random() * 4) + 1
    
          item["delivery_date"] = new Date(new Date().getTime() + (Math.random()*10*24*60*60*1000)).toDateString().slice(0, -4)
          commit('STORE_ITEMS')
          commit('ADD_ITEM_IN_CART', item)
          resolve('correcto')
        }
      });
    },
    updateItemQuantity({ commit }, payload){
      return new Promise((resolve, reject) => {
        commit('UPDATE_ITEM_QUANTITY', payload)
        commit('STORE_ITEMS')
        resolve('correcto')
      });
    },
    // PROCESOS PARA LA TIENDA SHOP, EN EL CUAL VALIDO CON UN INPUT NUMBER
    agregarProductoShop({ commit }, item) {
      return new Promise((resolve, reject) => {
        if(item.student.id_usuario_estudiante == null){
          location.reload();
        }
        else {
          var statusPreventa =  JSON.parse(localStorage.getItem('statusPreventa'));
        
          if(!statusPreventa) // cuando no es preventa canculo mi cantidad
          {
            // item['stock'] = item['stock'] - 5;
            // item['stock'] = item['stock'] - 1;
            item["cantidad"] = item["quantity"] = (item["cantidad"] == null) ? 1 : item["cantidad"];
            item["subtotal"] = _.round(item["price"] * item["cantidad"] ,4);
            item["total"]    = _.round( item["subtotal"],4 );
          } 
          else // cuando es preventa obtengo lo que necesito.
          {
            if(item["cantidad"] >= 1 ){
                item["quantity"] = item["cantidad"];
                item["subtotal"] = _.round(item["price"] * parseInt(item["quantity"]),4)  ;
                // item["subtotal"] = (Math.round(((item["price"] * parseInt(item["quantity"]))) * 100) /100 )  ;
                item["total"]    = _.round(item["subtotal"],4);
                // item["total"]    = Math.round( item["subtotal"] * 100 + Number.EPSILON ) / 100 ;
              }
            else{
              item["cantidad"] = item["quantity"] = (item["cantidad"] == null) ? 1 : item["cantidad"];
                item["subtotal"] =  _.round( item["price"] * item["cantidad"] ,4);
                item["total"]    = _.round(item["subtotal"],4);
                // item["subtotal"] = (Math.round(( item["price"] * item["cantidad"] ) * 100) /100 ) ;
                // item["total"]    = Math.round( item["price"] * 100 + Number.EPSILON ) / 100 ;
                // item["total"]    = Math.round( item["price"] * 100 + Number.EPSILON ) / 100 ;
    
            }
            var id_transporte = JSON.parse(localStorage.getItem('id_transporte'));
            var tipo_transporte =  JSON.parse(localStorage.getItem('tipo_transporte'));
            if(item['tipo_producto'] === tipo_transporte && item['cod_producto'] === id_transporte) item['stock']  = 1;
          }
    
    
          item["discount_in_percentage"] = Math.floor(Math.random() * 20) + 4
          item["offers_count"] = Math.floor(Math.random() * 4) + 1
    
          item["delivery_date"] = new Date(new Date().getTime() + (Math.random()*10*24*60*60*1000)).toDateString().slice(0, -4)
          commit('STORE_ITEMS')
          commit('AGREGAR_PRODUCTO_SHOP', item)
          resolve('correcto')
        }
      });
    },
    // PROCESOS PARA LA TIENDA SHOP, EN EL CUAL VALIDO CON UN INPUT NUMBER
    actualizarProductoShop({ commit }, payload){
      commit('ACTUALIZAR_PRODUCTO_SHOP', payload)
      commit('STORE_ITEMS')
    },
    storeItems({ commit }){
      commit('STORE_ITEMS')
    },
    deleteItems({ commit },payload){
      return new Promise((resolve, reject) => {
        commit('DELETE_ITEMS')
        resolve()
      });
    },
    agregarClasificacion({ commit }, payload){
      return new Promise((resolve, reject) => {
        commit('AGREGAR_CLASIFICACION',payload)
        resolve('correcto')
      });
    },
}
